import { Injectable } from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { ModalComponent } from '../custom-component/modal/modal.component';
import {
  getEducatorDuplicateDocumentModalConfig,
  isEducatorDuplicateDocumentProceed
} from '../constants/educator-duplicate-document-modal.util';

@Injectable({ providedIn: 'root' })
export class EducatorDuplicateDocumentModalService {
  private static readonly modalOptions: NgbModalOptions = {
    size: 'md',
    centered: true,
    backdrop: 'static',
    keyboard: true
  };

  constructor(private readonly modal: NgbModal) {}

  /** Resolves true when staff chooses Proceed & Upload. */
  async open(): Promise<boolean> {
    const modalRef = this.modal.open(ModalComponent, EducatorDuplicateDocumentModalService.modalOptions);
    modalRef.componentInstance.modalConfig = getEducatorDuplicateDocumentModalConfig();
    try {
      const result: unknown = await modalRef.result;
      return isEducatorDuplicateDocumentProceed(result);
    } catch {
      return false;
    }
  }
}
